import React, { useState, useEffect, useContext } from 'react';

import { makeStyles, withStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Button,
  TextField,

  IconButton,

} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import { green } from '@material-ui/core/colors';

import config from '../../../../config/config.json'
import OrderContext from '../../../../context/orderContext'


const useStyles = makeStyles(theme => ({
  addInput: {
    '& .MuiOutlinedInput-root': {
       '& fieldset': {
         borderColor: 'green',
         border: '2px solid green',
 
       },
     },
   },
 
}));

const Payment = props => {
  const { defaultPayment, onAddPayment,onChangePayment, onDeletePayment, index, type, payment, currenciesRate } = props;

  const orderContext = useContext(OrderContext);

  const classes = useStyles();

  const emptyState = config.defaultPaymentState
  // {
  //   amount: 0,
  //   currency: 4,
  //   type: 2
  // }
  const [values, setValues] = useState(emptyState);
  const [currentType, setCurrentType] = useState();



    // console.log('Payment ', type,payment,index)
  
  const handleChange = event => {
    // console.log('handleChange',event.target.name, event.target.value
    // }); )
    setValues({
      ...values,
      [event.target.id]: event.target.value
    });
  };



  useEffect(() => {
    if(currentType === 'add'){
    setValues({
      currency: emptyState.currency,
      type: emptyState.type,
      amount: props.defaultPayment
    })
  }
  }, [props.defaultPayment]);


  useEffect(() => {
    setCurrentType(props.type)
    if(props.type === 'view'){
      // console.log('Payment useEffect', type,payment,index)
      setValues(payment)
    }
  }, []);


  const paymentTypes = config.paymentTypes
  // [
  //   {
  //     value: 2,
  //     label: 'Наличные'
  //   },
  //   {
  //     value: 3,
  //     label: 'Альфасчет'
  //   },
  //   {
  //     value: 4,
  //     label: 'Вестерн Юнион'
  //   },

  // ];
  // const [paymentType, setPaymentType] = React.useState(0);

  const currencies = config.currencies
  // [
  //   {
  //     value: 4,
  //     label: '฿',
  //   },
  //   {
  //     value: 2,
  //     label: '$',
  //   },
  //   {
  //     value: 3,
  //     label: '€',
  //   },
  //   {
  //     value: 1,
  //     label: '₽ ',
  //   },
  // ];
  // const [currency, setCurrency] = React.useState('THB');


  const handelAddPayment = () => {
    // console.log('handelAddPayment')
    // if (values.amount  <= 0)  return
    onAddPayment(values, index)
    // setValues(emptyState)
  }

  const handelChangePayment = () => {
    // console.log('handelChangePayment')
    // if (values.amount  <= 0)  return
    onChangePayment(values, index)
    setCurrentType('view')

    // setValues(emptyState)
  }
  

  const handelEditPayment = () => {
    // console.log('handelEditPayment')
    setCurrentType('edit')
  }


  
  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="flex-start"
      spacing={3}
    >
      <Grid
        item
        xs={4}
      >

        <TextField
          fullWidth
          // style={{ border: '1px solid red',  backgroundColor: 'yellow'}}
          className={currentType === 'add' ? classes.addInput : ''}
          disabled={currentType === 'view'}
          label={currentType === 'add' ? 'Остаток' : 'Сумма'}
          margin="dense"
          id="amount"
          onChange={handleChange}
          required
          value={values ? values.amount : 0}
          variant="outlined"
          style={{ overflow: 'visible', zIndex: 0 }}
          helperText={currentType === 'add' ? values.amount > 0 ?`${Math.round(values.amount / currenciesRate[2]).toLocaleString('ru')} $, ${Math.round(values.amount / currenciesRate[3]).toLocaleString('ru')} €, ${Math.round(values.amount / currenciesRate[1]).toLocaleString('ru')} ₽, ${Math.round(values.amount / currenciesRate[5]).toLocaleString('ru')} Д` : '' : ''}
        />
      </Grid>

      <Grid
        item
        xs={4}
      >
        <TextField
          fullWidth
          className={currentType === 'add' ? classes.addInput : ''}
          select
          disabled={currentType === 'view'}
          style={{ overflow: 'visible', zIndex: 0 }}
          label="Тип платежа"
          value={values ? values.type : 2}
          id="type"
          onChange={handleChange}
          SelectProps={{
            native: true,
          }}
          margin="dense"
          variant="outlined"
        >
          {paymentTypes.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>

      </Grid>

      <Grid
        item
        xs={2}
      >
        <TextField
          fullWidth
          className={currentType === 'add' ? classes.addInput : ''}
          select
          disabled={currentType === 'view'}
          label="Валюта"
          value={values ? values.currency : 1}
          onChange={handleChange}
          id="currency"
          SelectProps={{
            native: true,
          }}
          margin="dense"
          variant="outlined"
        >
          {currencies.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
      </Grid>

      <Grid
        item
        xs={2}
      >
        {currentType === 'add' &&
          <IconButton aria-label="add" className={classes.margin} color="primary" onClick={handelAddPayment}>
            <AddIcon fontSize="small" />
          </IconButton>

        }
        {currentType === 'edit' &&
          <IconButton aria-label="save" className={classes.margin} color="primary" onClick={handelChangePayment}>
            <SaveIcon fontSize="small" />
          </IconButton>

        }
        {
          currentType === 'view' &&
          <React.Fragment>
            <IconButton aria-label="edit" className={classes.margin} color="primary" disabled={orderContext.actionType === 'edit'}  onClick={handelEditPayment}>
              <EditIcon fontSize="small" />
            </IconButton>
            {/* <IconButton aria-label="delete" className={classes.margin} color="primary" onClick={onDeletePayment(index)}> */}
            <IconButton aria-label="delete" className={classes.margin} color="primary" disabled={orderContext.actionType === 'edit'}  onClick={e => {
                          onDeletePayment(index);
                        }}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }

      </Grid>

    </Grid>

  );
};


export default Payment;
